/* eslint-disable dot-notation */
import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    ENV: process.env.VUE_APP_ENV,
    APIKey: process.env.VUE_APP_API_KEY
  }
});

export default {
  post (url, payload) {
    return apiClient.post(url, payload);
  },
  put (url, payload) {
    return apiClient.put(url, payload);
  },
  get (url) {
    return apiClient.get(url);
  }
};
